import { CredentialsFields } from 'main/gql/credentials'

import { School } from '../../types'

export enum StepType {
  INIT = 'start',
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  PAYMENT_METHOD = 'payment_method',
}

export interface IStep {
  current: StepType
  next: StepType | null
}

export interface ICoreProps {
  instantEnroll: boolean
  school: School
  changeStep: (step?: StepType) => void
}

export interface IExtraProps {
  onAuth: (credentials: CredentialsFields) => Promise<void>
  onComplete: () => void
}

export interface ITrackData {
  schoolId: number
  userId?: number
}
